import { useState } from 'react';
import {
  Dialog, DialogContent, DialogTitle, IconButton, Box,
  Typography, Button, Stack, Divider, Chip,
} from '@mui/material';
import { Close, Download, Android, QrCode2 } from '@mui/icons-material';
import { QRCodeSVG } from 'qrcode.react';

// APK lives at /fitistic.apk in the admin public folder.
// Works for both local dev and production since it's served from the same origin.
const APK_PATH = '/fitistic.apk';

export default function DownloadAppModal({ open, onClose }) {
  const apkUrl = `${window.location.origin}${APK_PATH}`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 4, overflow: 'hidden' },
      }}
    >
      {/* Header */}
      <DialogTitle sx={{ pb: 0, pt: 2.5, px: 3 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box
              sx={{
                width: 36, height: 36, borderRadius: 2,
                bgcolor: 'rgba(76,175,130,0.12)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >
              <Android sx={{ color: '#4CAF82', fontSize: 20 }} />
            </Box>
            <Box>
              <Typography fontWeight={700} fontSize={16}>Download Fitistic</Typography>
              <Typography variant="caption" color="text.secondary">Android APK</Typography>
            </Box>
          </Stack>
          <IconButton size="small" onClick={onClose}>
            <Close fontSize="small" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ px: 3, pt: 2, pb: 3 }}>
        {/* QR code */}
        <Box
          sx={{
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            bgcolor: '#F8F9FC', borderRadius: 3, p: 3, mb: 2.5,
            border: '1px solid #EEEEF5',
          }}
        >
          <Stack direction="row" alignItems="center" spacing={0.75} mb={2}>
            <QrCode2 sx={{ fontSize: 16, color: 'text.secondary' }} />
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              Scan with your Android phone
            </Typography>
          </Stack>

          <Box
            sx={{
              p: 1.5, bgcolor: 'background.paper', borderRadius: 2,
              boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            }}
          >
            <QRCodeSVG
              value={apkUrl}
              size={180}
              bgColor="#ffffff"
              fgColor="#1A1A2E"
              level="H"
              includeMargin={false}
              imageSettings={{
                src: '/logo.png',
                x: undefined,
                y: undefined,
                height: 36,
                width: 36,
                excavate: true,
              }}
            />
          </Box>

          <Typography variant="caption" color="text.secondary" mt={1.5} textAlign="center">
            Point your camera at the QR code to download
          </Typography>
        </Box>

        <Divider sx={{ mb: 2.5 }}>
          <Chip label="or" size="small" sx={{ fontSize: 11 }} />
        </Divider>

        {/* Direct download */}
        <Button
          variant="contained"
          fullWidth
          size="large"
          startIcon={<Download />}
          href={APK_PATH}
          download="fitistic.apk"
          sx={{
            bgcolor: '#4CAF82',
            '&:hover': { bgcolor: '#3d9e72' },
            borderRadius: 2,
            fontWeight: 700,
            py: 1.4,
          }}
        >
          Download APK Directly
        </Button>

        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          textAlign="center"
          mt={1.5}
          lineHeight={1.5}
        >
          Enable "Install from unknown sources" in Android settings before installing.
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
